import React, { type SVGProps } from "react";
import { illustrationSizes, type IllustrationProps } from "./utils/shared";
const Locked = (props: SVGProps<SVGSVGElement> & IllustrationProps) => (
  <svg
    width={props.size ? illustrationSizes[props.size] : illustrationSizes["s"]}
    height={props.size ? illustrationSizes[props.size] : illustrationSizes["s"]}
    viewBox="0 0 335 335"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="Locked"
    color="transparent"
    {...props}
  >
    <path
      opacity={0.2}
      d="M60.4481 288.237C84.5239 297.568 113.64 296.58 136.789 285.648C143.975 282.251 150.638 277.954 158.287 275.417C176.827 269.272 197.596 274.396 217.415 273.285C250.883 271.41 280.262 251.224 297.25 226.29C314.238 201.356 320.634 172.157 324.319 143.413C328.446 111.275 326.89 73.5725 297.282 53.7318C273.613 37.8653 240.243 39.4418 210.854 44.5245C181.465 49.6071 151.257 57.4186 122.096 51.4847C111.58 49.3526 101.423 45.4468 90.6309 44.9898C71.383 44.1687 53.6206 54.5693 41.2542 67.3239C20.0352 89.1981 10.7509 118.213 9.24637 146.698C7.73867 175.283 13.6076 204.022 14.49 232.462C15.2582 257.377 33.8966 277.935 60.4481 288.237Z"
      fill="#CFDAFF"
    />
    <rect x={148} y={94.6} width={40} height={81} rx={20} stroke="white" strokeWidth={20} />
    <rect x={148} y={94.6} width={40} height={81} rx={20} stroke="#B1C3FF" strokeWidth={20} />
    <rect x={103} y={124.6} width={124} height={92} rx={8} fill="white" />
    <rect x={103} y={124.6} width={124} height={92} rx={8} fill="#B1C3FF" />
    <ellipse cx={165.122} cy={159.479} rx={11.095} ry={11.4913} fill="#4E72EA" />
    <path
      d="M153.201 192.178L160.917 166.063C161.168 165.213 161.949 164.63 162.835 164.63H168.256C169.163 164.63 169.956 165.24 170.189 166.116L177.134 192.231C177.471 193.5 176.515 194.745 175.201 194.745H155.119C153.783 194.745 152.822 193.46 153.201 192.178Z"
      fill="#4E72EA"
    />
  </svg>
);
export default React.memo(Locked);
